export default __webpack_public_path__ + "static/media/General_01_02.d7931964.png";